import type { CollisionMask } from '../sim/collisionMask';

export function createCrater(terrain: CollisionMask, x: number, y: number, radius: number): void {
  terrain.destroyCircle(x, y, radius);
}

export function createExplosion(
  terrain: CollisionMask,
  x: number,
  y: number,
  radius: number,
): { affectedArea: { minX: number; minY: number; maxX: number; maxY: number } } {
  createCrater(terrain, x, y, radius);

  return {
    affectedArea: {
      minX: x - radius,
      minY: y - radius,
      maxX: x + radius,
      maxY: y + radius,
    },
  };
}

export function calculateExplosionDamage(
  explosionX: number,
  explosionY: number,
  explosionRadius: number,
  maxDamage: number,
  targetX: number,
  targetY: number,
  pushMultiplier: number = 1,
): { damage: number; pushX: number; pushY: number } {
  const dx = targetX - explosionX;
  const dy = targetY - explosionY;
  const distance = Math.sqrt(dx * dx + dy * dy);

  if (distance >= explosionRadius) {
    return { damage: 0, pushX: 0, pushY: 0 };
  }

  const normalizedDist = distance / explosionRadius;
  const falloff = 1 - normalizedDist * normalizedDist;
  const damage = Math.round(maxDamage * falloff);

  const pushMagnitude = falloff * 300 * pushMultiplier;
  const angle = Math.atan2(dy, dx);
  const pushX = Math.cos(angle) * pushMagnitude;
  const pushY = Math.sin(angle) * pushMagnitude - pushMagnitude * 0.5;

  return { damage, pushX, pushY };
}
